import { RoutesConstants } from "@/main/routes/routesConstants";
import { ParameterTypeEnum } from "@/main/services/enum/ParameterTypeEnum";
import { isNullUndefined } from "@/main/services/utils";
import { ParameterByTypeScreenState, mountKeyParameterByTypeScreen } from "@/main/store/parameterByTypeScreen";

type TypeRoutesConstants = keyof typeof RoutesConstants;

export const SCREEN_PARAMETER: Partial<Record<TypeRoutesConstants, ParameterTypeEnum[]>> = {
	orderSearchOrder: [
		ParameterTypeEnum.DefaultSearchOrderDaysInterval,
		ParameterTypeEnum.OrderScreenFilterClaimLength,
		ParameterTypeEnum.SingleStatusSearchOrderDaysInterval,
	],
	quotationCartPendingToAnswer: [ParameterTypeEnum.DefaultSearchCartDaysInterval],
	reportOrder: [ParameterTypeEnum.DefaultSearchOrderReportDaysInterval],
	inventorySearchImport: [ParameterTypeEnum.DefaultSearchImportsInterval, ParameterTypeEnum.MaximumImportLines],
	claimSearchClaims: [
		ParameterTypeEnum.SearchClaimsInteval,
		ParameterTypeEnum.ClaimScreenFilterClaimLength,
		ParameterTypeEnum.MaxSearchRangeDaysClaimSearchScreen,
	],
	claimSearchRefund: [ParameterTypeEnum.ClaimScreenFilterClaimLength],
	reportBillingOrder: [ParameterTypeEnum.DefaultSearchReporBillingDaysInterval],
	reportShippingCost: [ParameterTypeEnum.DefaultShippingCostReportInterval],
	orderManagePackages: [ParameterTypeEnum.DefaultSearchPackageManageDaysInterval],
	reportSupplierPerformance: [ParameterTypeEnum.DefaultSupplierPerformanceDaysInterval],
	reportRequoteTraceability: [
		ParameterTypeEnum.DefaultRequoteReportDaysInterval,
		ParameterTypeEnum.RequoteTraceabilityScreenFilterClaimLength,
	],
	reportOrderReportSchedule: [
		ParameterTypeEnum.DefaultSearchOrderReportScheduleDaysInterval,
		ParameterTypeEnum.MaximumSearchOrderReportScheduleDaysInterval,
	],
	dynamicReport: [ParameterTypeEnum.DynamicReportTimeout],
	orderReassignOrder: [ParameterTypeEnum.MinimumDiscountForTotalLossTransfer],
	orderReassignOrderBulk: [ParameterTypeEnum.MinimumDiscountForTotalLossTransfer],
	integrationQueue: [ParameterTypeEnum.ClaimScreenFilterClaimLength],
	registrationSearchAnnouncement: [
		ParameterTypeEnum.DefaultSearchAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumSearchAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumCreateAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumCreateAnnouncementFile,
	],
	registrationRegisterAnnouncement: [
		ParameterTypeEnum.DefaultSearchAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumSearchAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumCreateAnnouncementDaysInterval,
		ParameterTypeEnum.MaximumCreateAnnouncementFile,
	],
	partsCancelledBySupplier: [
		ParameterTypeEnum.SearchRangeDaysManagePartsCancelled,
		ParameterTypeEnum.PartsCancelledMaxSelect,
		ParameterTypeEnum.MaxDeadlineAnswerRequote,
		ParameterTypeEnum.MinDeadlineAnswerRequote,
	],
	quotationCartCreateAnswer: [ParameterTypeEnum.MaximumSupplierItemImageSize],
};

export const isEmptyLoadingParametersScreen = (
	parametersByTypeScreenReducer: ParameterByTypeScreenState,
	keysParametersToValid: number[],
) => {
	return keysParametersToValid.some((key) => {
		const parameter = parametersByTypeScreenReducer.isolated[mountKeyParameterByTypeScreen(key)] ?? null;
		if (isNullUndefined(parameter)) return true;
		return (parameter && parameter.isLoading) || isNullUndefined(parameter.data);
	});
};
export const isValidAllParametersScreen = (
	parametersByTypeScreenReducer: ParameterByTypeScreenState,
	keysParametersToValid: number[],
) => {
	const isAllFinished = keysParametersToValid.every((key) => {
		const parameter = parametersByTypeScreenReducer.isolated[mountKeyParameterByTypeScreen(key)] ?? null;
		if (isNullUndefined(parameter)) return false;
		return parameter && !parameter.isLoading && !parameter.isError && !isNullUndefined(parameter.data);
	});

	return isAllFinished;
};
